import { jsx } from './jsx-runtime';
const Registry = new WeakMap();
export const fromElement = (Element, options = {})=>{
    let fn = Registry.get(Element);
    if (fn) return fn;
    const tag = 'x-' + Element.name.toLowerCase() + (Math.random() * 10000000 | 0).toString(36);
    const ctor = class extends Element {
    };
    customElements.define(tag, ctor, options);
    if (options.extends) fn = (props)=>jsx(options.extends, Object.assign(props, {
            is: tag
        }), void 0)
    ;
    else fn = (props)=>jsx(tag, props, void 0)
    ;
    Registry.set(Element, fn);
    fn.toString = ()=>tag
    ;
    return fn;
};
